import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceImporter  {
    _originalTypeClassName = "zERP.BO.InvoiceImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceImporter.translate = translateService;
}
this.InvoiceImporterKey = null;
this._key = this.InvoiceImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _InvoiceImporterKey:any;
get InvoiceImporterKey(): any {
    return this._InvoiceImporterKey;
  }
set InvoiceImporterKey(value: any) {
    this._InvoiceImporterKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InvoiceImporterKey == null || $this.InvoiceImporterKey == 0;
            }


}